import { metaAccount } from '@/router/meta-config'
const permissionKey = 'KIOSK'
// mock KIOSK (STREAM)

export default [
  // Stands
  {
    path: '/streams',
    name: 'page-streams',
    component: () => import('@/pages/streams'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/stream/new',
    name: 'page-stream-new',
    component: () => import('@/pages/stream'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/stream/:id',
    name: 'page-stream',
    component: () => import('@/pages/stream'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
